<patient-overview
	[hasActiveFilters]="hasActiveFilters$ | async"
	[patients]="patients$ | async"
	[taskToggleValue]="taskFilter$ | async"
	(details)="showDetails($event)"
	(toggleTasks)="togglePatientWithTasks()"
/>
